export { default } from './CssBaseline';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/CssBaseline/index.js
// module id = 320
// module chunks = 0